import React, { useContext, useState } from 'react'
import RenderProfAccDetailsGrid from './RenderProfAccDetailsGrid';
import { deleteUpdateOnProfAccApi, denyUserApi } from 'Constants';
import { Context } from 'Context/Context';


function ProfessionalAccountUpdates({updatesSent, labels, buttonName="Delete updates", setReRenderData, isDenied, showEditOrPopup}) {
  const [isChange, setIsChange] = useState(false);
  const [isAttChange, setIsAttChange] = useState(false);
 const {makeApiCallFunc} = useContext(Context);
  const deleteUpdate = () => {
    makeApiCallFunc(
        deleteUpdateOnProfAccApi +  updatesSent?._id,
        null,
        (data) => {
            console.log(data);
            setReRenderData(prev => !prev)
        },
        (data) => console.log(data),
    )
}
const newUpdate = () => {
    showEditOrPopup();
}

    
       const attorneyLabels = {
        "Attorney's Profile picture" : "profilePic",
        "Attorney's first name" : "firstName",
        "Attorney's last name" : "lastName",
        "Attorney's email" : "email",
        "Attorney's Law Firm Link" : "lawFirmLink",
        "Attorney's linkedin" : "linkedin",

       }
  return (
    <div className='flex w-full flex-col lg:pt-10  py-8 text-sm py-4 pt-0 '>
        {/* {isChange && 
        <div className='font-semibold mb-4 mt-8 w-full p-2 pl-10 '>Details sent to admin:</div>
        } */}
        <RenderProfAccDetailsGrid
        user={updatesSent?.user}
        updatedUserInfo={updatesSent?.updatedUserInfo}
        setIsChange={setIsChange}
        changeOrg = {updatesSent?.changeOrg}
        data={labels} />
        {
            updatesSent?.user?.isUserAssistant &&
            <div>
                {isAttChange &&
            <div className='font-spectral font-bold text-navy mb-4 border-t border-gray-200 mt-4 bg-cream rounded-lg p-3 w-full pl-6'>Attorney you are acting on behalf of</div>
                }
            <RenderProfAccDetailsGrid
            setIsChange={setIsAttChange}
            updatedUserInfo={updatesSent?.updatedUserInfo?.attorney}
            data={attorneyLabels} />
            </div>
        }
        {
            isDenied ?

            <div className='flex w-full justify-left'>
                {/* {!updatesSent?.changeOrg &&
            <div className=' mt-10 ml-10 justify-left flex '>
                <div className=' text-green-600 cursor-pointer rounded w-max p-1 text-sm  border border-green-600 bg-green-200' onClick={newUpdate}> Make a new update</div>
            </div>} */}
             {/* <div className=' mt-10 ml-10 justify-left flex '>
                <div className=' cursor-pointer text-sky-600 rounded w-max p-1 text-sm  border border-sky-600 bg-white' onClick={deleteUpdate}>Delete this entry</div>
            </div> */}
            </div>
            :
            <div className='w-full mt-10 ml-10 justify-left flex '>
                <div className=' cursor-pointer text-tan rounded w-max p-1 text-sm  border border-tan bg-white hover:bg-cream' onClick={deleteUpdate}>{buttonName}</div>
            </div>
        }
       
  
    </div>
  )
}

export default ProfessionalAccountUpdates